import { type FC, useEffect, useState } from "react";
import ImageMapLeaflet from "@/components/Leaflet/ImageMapLeaflet";
import Api from "@/services/Api";

export type MarkerPosition = { x: number; y: number };

export interface MarkerFormData {
  coordinates: MarkerPosition;
  [key: string]: any;
}

interface ImageMapLeafletLoaderProps {
  mediaId: number;
  markers: MarkerFormData[];
  setMarkers: any;
}

const ImageMapLeafletLoader: FC<ImageMapLeafletLoaderProps> = ({ mediaId, markers, setMarkers }) => {
  const [imgSize, setImgSize] = useState<{ width: number; height: number } | null>(null);
  const [mapImageUrl, setMapImageUrl] = useState<string | undefined>();

  useEffect(() => {
    const loadMedia = Api.getOneMedia(mediaId);
    loadMedia.fetchDirect(null).then((res) => {
      const img = new Image();
      if (res?.src) {
        setMapImageUrl(res.src);
        img.src = res.src;

        img.onload = () => {
          const imgHeight = img.naturalHeight;
          const imgWidth = img.naturalWidth;
          setImgSize({ width: imgWidth, height: imgHeight });
        };
        img.onerror = () => {
          console.error("Failed to load image:", mediaId);
        };
      }
    });
  }, [mediaId]);

  return (
    <>
      {!!mapImageUrl && !!imgSize && (
        <ImageMapLeaflet
          /*key={"key_"+mapImageUrl.toString()}*/ imgUrl={mapImageUrl}
          width={imgSize.width}
          height={imgSize.height}
          markers={markers}
          setMarkers={setMarkers}
        />
      )}
    </>
  );
};
export default ImageMapLeafletLoader;
